<div class="w-full">
  <!-- Header Section -->
  <div
    class="mb-5 mt-2.5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
  >
    <h3 class="text-left font-sans text-lg font-light">{{ title }}</h3>
    <button
      (click)="viewMore()"
      class="flex cursor-pointer items-center gap-1 self-start border-none bg-transparent text-[#20345F] outline-none hover:underline sm:self-auto"
    >
      <span>View More</span>
      <mat-icon aria-label="View more">arrow_right_alt</mat-icon>
    </button>
  </div>

  <!-- Data Grid Section -->
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
    @for (i of info; track $index) {
      <div class="flex flex-col text-left">
        <span class="mb-1 font-sans text-sm font-bold">
          {{ i.title }}
        </span>
        <span
          class="whitespace-normal break-words font-sans text-sm font-light"
        >
          {{ i.value || '-' }}
        </span>
      </div>
    }

    @if (order.canceled) {
      <div class="flex flex-col text-left">
        <span class="mb-1 font-sans text-sm font-bold">
          Cancelation Date:
        </span>
        <span
          class="whitespace-normal break-words font-sans text-sm font-light"
        >
          {{ order.cancel_date | date: 'yyyy-MM-dd' }}
        </span>
      </div>
    }
  </div>
</div>
